<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="標準代碼">
              <a-input  v-model="queryParam.codeId"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="標準代碼名稱">
              <a-input  v-model="queryParam.codeDesc"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="父代碼">
              <a-input  v-model="queryParam.codeGroup"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="標準代碼類型">
              <a-input  v-model="queryParam.codeType"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="是否有效">
              <a-select v-model="queryParam.codeStatus" placeholder="請選擇是否有效" allowClear>
                <a-select-option value="Y">Y</a-select-option>
                <a-select-option value="N">N</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('emp_chr_code')">导出</a-button>
      <a-button type="primary" icon="sync" @click="handleSyncAll">同步（所有）</a-button>
      <a-button type="primary" icon="sync" @click="handleSyncByCodeType">同步（by標準類型代碼）</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <p>備註：</p>
        <p>ELEVEL-用工類型  BU-事業群 OWNER-法人 FACTORY-廠區 SITEID-siteId JOB_ST-jobSt </p>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>

            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <emp-chr-code-modal ref="modalForm" @ok="modalFormOk"></emp-chr-code-modal>

    <a-modal
      title="同步标准代码"
      :visible="syncModalVisible"
      @ok="confirmSyncByCodeType"
      @cancel="cancelSyncModal"
      :confirmLoading="syncModalConfirmLoading"
    >
      <a-form>
        <a-form-item label="标准类型代码" :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
          <a-input v-model="codeTypeInput" placeholder="请输入标准类型代码" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpChrCodeModal from './modules/EmpChrCodeModal'
  import {Modal} from "ant-design-vue";

  export default {
    name: 'EmpChrCodeList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EmpChrCodeModal
    },
    data () {
      return {
        description: 'emp_chr_code管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'標準代碼',
            align:"center",
            dataIndex: 'codeId'
          },
          {
            title:'標準代碼名稱',
            align:"center",
            dataIndex: 'codeDesc'
          },
          {
            title:'父代碼',
            align:"center",
            dataIndex: 'codeGroup'
          },
          {
            title:'標準代碼類型',
            align:"center",
            dataIndex: 'codeType'
          },
          {
            title:'描述',
            align:"center",
            dataIndex: 'description'
          },
          {
            title:'是否有效',
            align:"center",
            dataIndex: 'codeStatus'
          },
          {
            title:'排序',
            align:"center",
            dataIndex: 'orderNo'
          },
          {
            title:'更新時間',
            align:"center",
            dataIndex: 'updateDate'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/sys/chrCode/empchrcodes",
          delete: "/sys/chrCode/empchrcode",
          deleteBatch: "/sys/chrCode/empchrcode/batch",
          exportXlsUrl: "/sys/chrCode/export-xls",
          importExcelUrl: "sys/chrCode/import-excel",
          syncChrCode: "/sys/chrCode/syncChrCode"
        },
        dictOptions:{},
        superFieldList:[],
        syncModalVisible: false,
        syncModalConfirmLoading: false,
        codeTypeInput: ''
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      initDictConfig(){
      },
      // 同步所有数据
      handleSyncAll() {
        const that = this;
        this.$confirm({
          title: '确认同步',
          content: '确定要同步所有标准代码吗？',
          onOk: function() {
            that.syncChrCodeData();  // 不传参数表示同步所有
          }
        });
      },

      // 按标准类型代码同步
      handleSyncByCodeType() {
        this.codeTypeInput = '';
        this.syncModalVisible = true;
      },

      // 确认同步
      confirmSyncByCodeType() {
        if (!this.codeTypeInput || this.codeTypeInput.trim() === '') {
          this.$message.warning('标准类型代码不能为空');
          return;
        }

        this.syncModalConfirmLoading = true;
        this.syncChrCodeData(this.codeTypeInput.trim()).finally(() => {
          this.syncModalConfirmLoading = false;
          this.syncModalVisible = false;
        });
      },

      // 取消同步弹窗
      cancelSyncModal() {
        this.syncModalVisible = false;
        this.codeTypeInput = '';
      },

      // 调用同步接口的实际方法（修改返回Promise）
      syncChrCodeData(codeType = '') {
        const that = this;
        this.loading = true;

        // 构造请求参数
        const params = {};
        if (codeType) {
          params.codeType = codeType;
        }

        return this.$http.post(this.url.syncChrCode, params).then((res) => {
          if (res.success) {
            this.$message.success(res.message || '同步成功');
            // 同步完成后刷新列表
            this.loadData();
          } else {
            this.$message.error(res.message || '同步失败');
            return Promise.reject(res.message);
          }
        }).catch((err) => {
          this.$message.error('同步过程中发生错误: ' + (err.message || err));
          return Promise.reject(err);
        }).finally(() => {
          this.loading = false;
        });
      },


    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
